import React, { useState } from "react";
import "./login.css";
import { auth } from "../../utils/firebase"; 
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext/AppContext";
import KidsLogin from "../../component/KidsLogin/KidsLogin"


function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const { setUserInfo } = useAppContext();

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
    
        try {
          const userCredential = await signInWithEmailAndPassword(auth, username, password);
          const user = userCredential.user;
          setUserInfo(user);
          // Redirect or show dashboard
          navigate("/dashboard");
        } catch (err) {
          console.error("Login error:", err.message);
          setError("Invalid email or password");
          alert("Invalid email or password");
        }
    };

  return <KidsLogin {
    ...{
      username, setUsername,
      password, setPassword,
      handleLogin,
      error, setError
    }
  } />
    
// Old UI
  return (
    <div className="login-container">
      <h2>Login into your course Dashboard</h2>
      {/* OR use <h2>Student Login</h2> */}
      <form onSubmit={handleLogin}>
        <div className="input-group">
          <label>Email</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default Login;
